// import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { COLORS } from '@bumble/app/theme';
import { Box, Card, CardContent } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Loading } from './Loading';

interface NodeHealthTestProps {
  nodeId: string;
}
export const NodeHealthTest = ({ nodeId }: NodeHealthTestProps) => {
  const api = useApi();
  const { isLoading, isFetching, data } = useQuery(
    ['healthCheck'],
    api.runHealthCheckApiV1RunHealthCheckPost.bind(null, {
      node_id: nodeId,
    }),
    { cacheTime: 0 },
  );

  return (
    <Box>
      {isLoading || isFetching ? <Loading height={280} /> : null}
      {!isLoading && !isFetching && data?.data && (
        <Card variant="outlined">
          <CardContent sx={{ backgroundColor: COLORS.BACKGROUND }}>
            <Box component="pre" sx={{ m: 0 }}>
              <Box component="code">{JSON.stringify(JSON.parse(data?.data), null, 4)}</Box>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};
